const getters = {
    getBillRequests(state) {
        return state.billRequestsList;
    },
    getAllBillRequests(state) {
        return state.allBillRequests;
    },
    getBillRequestMeta(state) {
        return state.billRequestMeta;
    }
}

export default getters;

